import { render, staticRenderFns } from "./RoomsView.vue?vue&type=template&id=da3bf944&"
import script from "./RoomsView.vue?vue&type=script&lang=ts&"
export * from "./RoomsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports